import { userForgetPasswordSuccess, userForgetPasswordError } from "./reducer";

import {
  postForgetPwd,
  passwordReset as passwordResetApi,
} from "../../../apiCalls/caller";

export const userForgetPassword = (user, history) => async (dispatch) => {
  try {
    let response;

    response = postForgetPwd(user);

    const data = await response;

    if (data) {
      dispatch(
        userForgetPasswordSuccess("Reset link has been sent to your mailbox.")
      );
    }
  } catch (forgetError) {
    dispatch(userForgetPasswordError(forgetError));
  }
};
